<template>
  <audio controls>
    <source
      src="https://cdn.radiofrance.fr/s3/cruiser-production/static/culture/sons/2012/01/s03/Sur_les_docks--PODCAST--NET_badcf5be-a0c7-4aa8-9cc8-938ecdd65886_FC.mp3"
    />
  </audio>
</template>

<script>
/**
 * @module component - AudioInterview
 */
export default {
  name: "AudioInterview",
};
</script>

<style>
</style>